import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {
  CommReportKpiConfigByPlan,
  KpiColumnConfig
} from '../../shared/utils/commission-report-pivot.util';

function normalizeConfigByPlan(raw: CommReportKpiConfigByPlan | Record<string, KpiColumnConfig[]> | null | undefined): CommReportKpiConfigByPlan {
  const result: CommReportKpiConfigByPlan = {};
  if (!raw) {
    return result;
  }

  Object.keys(raw).forEach(key => {
    const planId = Number(key);
    if (!Number.isNaN(planId)) {
      result[planId] = raw[key as keyof typeof raw] || [];
    }
  });

  return result;
}

@Injectable({
  providedIn: 'root'
})
export class CommissionReportConfigService {

  private host = environment.apiUrl + 'reviewcommissions';

  constructor(private http: HttpClient) {}

  loadKpiConfigs(commPlanIds: number[]): Observable<CommReportKpiConfigByPlan> {
    const ids = (commPlanIds || [])
      .map(id => Number(id))
      .filter(id => !Number.isNaN(id));
    if (!ids.length) {
      return of({});
    }

    return this.http.put<CommReportKpiConfigByPlan>(`${this.host}/commreportkpiconfig/load`, {
      commissionPlanId: ids
    }).pipe(
      map(response => normalizeConfigByPlan(response))
    );
  }

  saveKpiConfig(
    commPlanId: number,
    salesChannel: string,
    kpiColumnConfigs: KpiColumnConfig[],
    updatedBy: string
  ): Observable<{ success: boolean; message?: string }> {
    return this.http.put<{ success: boolean; message?: string }>(`${this.host}/commreportkpiconfig/save`, {
      commPlanId,
      salesChannel,
      kpiColumnConfigs,
      updatedBy
    }).pipe(
      map(response => response || { success: true })
    );
  }
}
